/* eslint-disable*/
import {Component} from "react";
import Header from "../../../components/Header/Header";
import {Container, Row, Col, CardImg, Card, Button, Table} from "reactstrap";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import React from "react";
import './ViewLecture.scss';
import * as constants from "../../../const/constants";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import SectionPolygon from "../../../components/SectionPolygon/SectionPolygon";
import * as actionCreator from "../../../store/domain/classes/action";
import * as commonFunc from "../../../utils/commonFunc";
import moment from "moment";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as classService from "../../../services/class";
import * as actionModalCreator from "../../../store/domain/modal/action";
import {lang, language} from "../../../const/language";
import AuthButtonGroup from "../../../components/AuthButtonGroup/AuthButtonGroup";
import swal from "sweetalert";
import {DatePicker} from 'antd';
import {setPaymentModal_} from "../../../store/domain/modal/action";

import {Replay} from 'vimond-replay';
import 'vimond-replay/index.css';
import HlsjsVideoStreamer from 'vimond-replay/video-streamer/hlsjs';
import VideoPLayer from "../../../components/VideoPlayer/VideoPLayer";
import {notifyMessage} from "../../../utils/commonFunc";
import toastr from "toastr";
import i from "react-icofont";
import HomeView from "../landing/version-01/homeView/HomeView";
import webConfig from '../../../config/WebConfig'

const {MonthPicker} = DatePicker;
const dateFormat = 'YYYY/MMMM';

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/19/20
 * Time: 1:19 PM
 */

class App extends Component {
    handlePageClick = (value) => {
        this.fetchClassesFromHome(value.selected);
    };
    joinClassHandler = (object) => {
        commonFunc.joinClassHandler(this.props, object)
    };

    checkClass = async () => {
        let state = this.props.location.state;

        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 10});
            await classService.getClassDetailsById(state)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success) {
                        this.props.selectClassHandler(response.body);
                    } else {
                        commonFunc.notifyMessage(response.message, response.status);
                        this.goHome();
                    }
                })
        } else {
            this.goHome();
        }
    };


    checkClassByToken = async () => {
        let state = this.props.location.state;

        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 10});
            await classService.getClassDetailsByIdWithToken(state)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success) {
                        this.props.selectClassHandler(response.body);
                    } else {
                        commonFunc.notifyMessage(response.message, response.status);
                        this.goHome();
                    }
                })
        } else {
            this.goHome();
        }
    };

    goHome = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
    };

    redirectBack = (id) => {
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
            state: `${id}`
        })
    };

    purchaseHandler = (date, classId, classDetails) => {
        this.props.setPaymentModal(true, {classId: classId, classDetails: classDetails})
        // let months = dropdownConst.months;
        // let curMonth = new Date(date).getMonth();
        // let curYear = new Date(date).getFullYear();
        //
        // let obj = { month: months[curMonth].value, year: curYear, classId: classId };
        // commonFunc.studentPurchaseWarning(this.props, obj);
    };
    setModalHandler = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)

    };

    viewClassLessons = () => {
        commonFunc.viewClassResources(this.props, parseInt(this.props.location.state));
    };

    componentWillUnmount() {
        this.props.selectClassHandler(null);
    }

    async componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;

        let pathname = this.props.location.pathname;
        let array = pathname.split('/');
        let hashCode = (array[array.length - 1]);
        let checkType = (array[array.length - 2]);
        this.props.spinnerHandler({isSpin: true, type: 15});
        if (hashCode.length === 6 && checkType === 'pay-class') {
            classService.paymentUrlNavigation(hashCode).then(res => {
                if (res.success) {
                    let isEnrolled = res.body.enrolled;
                    // this.props.spinnerHandler({isSpin: true, type: 10});
                    classService.getClassDetailsById(res.body.classId)
                        .then(response => {
                            this.props.spinnerHandler(false);
                            if (response.success) {
                                this.props.selectClassHandler(response.body);
                                if (!isEnrolled) {
                                    this.props.setPaymentModal(true, {
                                        classId: res.body.classId,
                                        classDetails: response.body
                                    })
                                }
                            } else {
                                commonFunc.notifyMessage(response.message, response.status);
                                this.goHome();
                            }
                        })
                } else {
                    this.goHome();
                }

            })
        } else if (hashCode.length === 6 && checkType === 'join-class') {
            classService.JoinClassNavigation(hashCode).then(
                response => {
                    if (!response.success) {
                        this.props.spinnerHandler(false);
                        classService.getClassDetailsByHashcode(hashCode).then(res => {
                            let classDetails = res.body;
                            this.props.selectClassHandler(classDetails);
                            this.props.location.state = classDetails.id;
                            this.props.spinnerHandler(false);
                            this.props.history.push({
                                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
                                state: `${classDetails.id}`
                            })
                        });
                        notifyMessage(response.message, response.status);
                    } else {
                        let obj;
                        let body = response.body;
                        if (body.zoomMeetingJoinType === 'UNAUTHORIZED') {
                            obj = {
                                zoomMeetingId: body.zoomMeetingId,
                                zoomMeetingPassword: body.zoomMeetingPassword,
                                zoomSignatureJwt: body.zoomSignatureJwt,
                                classId: body.classId,
                                zoomMeetingJoinType: body.zoomMeetingJoinType
                            };
                            this.props.spinnerHandler(false);
                            this.props.history.push({
                                pathname: `${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ROUTE}`,
                                state: obj
                            })
                        } else {
                            classService.joinZoomClassAuthorized(body.classId).then(res => {
                                if (res.success) {
                                    this.props.spinnerHandler(false);
                                    obj = {
                                        link: res.body,
                                        zoomMeetingJoinType: 'AUTHORIZED'
                                    };
                                    // this.props.history.props.spinnerHandler(false);
                                    this.props.history.props.push({
                                        pathname: `${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ROUTE}`,
                                        state: obj
                                    })
                                } else {
                                    //props.spinnerHandler(false);
                                    this.props.spinnerHandler(false);
                                    let msgType = 'warning';
                                    toastr[msgType](res.message);
                                }
                            }).catch(err => {
                                this.props.spinnerHandler(false);
                                console.log(err)
                            });
                        }


                    }
                }
            )
        } else {
            if (this.props.location.search.split('?paynow=')[1] === 'Y') {
                await this.checkClass();
                document.getElementById("pay-btn").click();
            } else {
                await this.checkClassByToken();
            }


        }


    }


    joinClass = (selectClass) => {
        if (this.props.userType === 1) {
            commonFunc.joinClassHandler(this.props, selectClass)
        } else {
            swal({
                title: language[lang].StudentSignInWarning3,
                icon: null,
                closeOnClickOutside: false,
                buttons: {
                    cancel: language[lang].NotNowText,
                    dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                },
            }).then((value) => {
                switch (value) {
                    case "action":
                        window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                        break;
                    default:
                        break;
                }

            });
        }
    };

    joinFreeClass = async (object, type) => {
        if (object.buttonStatus === constants.BUY_TEXT) {
            if (this.props.userType !== 1) {
                swal({
                    title: type === 'class' ? language[lang].StudentSignInWarning3 : language[lang].StudentSignInWarningForClassLesson,
                    icon: null,
                    closeOnClickOutside: false,
                    buttons: {
                        cancel: language[lang].NotNowText,
                        dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                    },
                }).then((value) => {
                    switch (value) {
                        case "action":
                            window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                            break;
                        default:
                            break;
                    }
                });
            } else {

                this.props.spinnerHandler({isSpin: true, type: 15});

                const data = {
                    classId: object.id,
                    studentId: this.props.userObj.id,
                    year: moment().format('YYYY'),
                    month: moment().format('MMMM').toUpperCase()
                };

                // this.props.spinnerHandler(false);
                await classService.joinFreeClass(data)
                    .then(response => {

                        this.props.spinnerHandler(false);
                        if (response.success) {
                            if (type === 'class') {
                                commonFunc.joinClassHandler(this.props, object)
                            } else {
                                this.viewClassLessons()
                            }
                        } else {
                            commonFunc.notifyMessage(response.message, response.status);
                        }
                    })
            }
        } else {
            if (type === 'class') {
                commonFunc.joinClassHandler(this.props, object)
            } else {
                this.viewClassLessons()
            }
        }
    }

    viewClassPapers = (object) => {
        commonFunc.viewPaperResources(this.props, object.id, true);
    }

    render() {


        let {selectClass, userType} = this.props;

        let firstWeek = new Date().getDate() <= constants.FREE_CLASS_DURATION;
        console.log(selectClass ? selectClass : 'nathoo')
        return (

            <div className={userType !== 1 ? "guest-user-view-class lec-view-class" : "lec-view-class"}>
                <Header/>

                <div>
                    <main ref="main">
                        {<HomeView img={this.props?.selectClass?.imageUrl}/>}

                        {selectClass &&
                        <div className="container">
                            <Row>
                                <Col className='d-flex flex-column justify-content-center text-center ' sm={12} md={12}
                                     lg={12}>
                                    <h1 className='class-name body-topic'>{selectClass.name}</h1>
                                    <h3 className='teacher-name'>By {selectClass.teacher.teacherName}</h3>
                                    <p className='class-desc'> {selectClass.description}</p>
                                </Col>
                            </Row>

                            <Row className='d-flex justify-content-center'>
                                <Col sm={12} md={12} lg={8} xl={6} className={'time-table'}>
                                    {selectClass.dayTimes && <Table
                                        bordered
                                        hover
                                        responsive
                                        striped
                                    >
                                        <thead>
                                        <tr>
                                            <th className='table-header-bar'>
                                                DATE
                                            </th>
                                            <th className='table-header-bar'>
                                                TIME
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {selectClass.dayTimes.map((dateTime, index) => <tr>
                                            <td className='table-header-bar' scope="row">
                                                {dateTime.dayName}
                                            </td>
                                            <td className='table-header-bar'>
                                                {`${moment(`2000-01-01 ${dateTime.startTime}`).format('h:mm a')} to ${moment(`2000-01-01 ${dateTime.endTime}`).format('h:mm a')}`}
                                            </td>

                                        </tr>)}

                                        </tbody>
                                    </Table>}
                                </Col>

                            </Row>

                            {webConfig.LMSStatus === 'LMS' ?
                               <div className='d-flex justify-content-center'>
                                   {
                                       selectClass.fee === 0 ?
                                           <div className={"button-ctrl"}>
                                               {
                                                   (selectClass.teacher.privileges.split(':')[0] === '1') ?
                                                       <Button
                                                           className="com-btn log-btn mt-3 auto-width"
                                                           onClick={() => this.joinFreeClass(selectClass,'class')}>
                                                           {`${language[lang].JoinTheClass}`}
                                                       </Button> : null
                                               }
                                               {
                                                   (selectClass.teacher.privileges.split(':')[1] === '1') ?
                                                       <Button
                                                           className="com-btn log-btn mt-3 auto-width"
                                                           onClick={() => this.joinFreeClass(selectClass,'video')}>
                                                           {`${language[lang].ClassResources}`}
                                                       </Button> : null
                                               }
                                               {
                                                   (selectClass.teacher.privileges.split(':')[3] === '1' &&
                                                       selectClass.buttonStatus === constants.BOUGHT_TEXT) ?
                                                       <Button
                                                           className="com-btn log-btn mt-3 auto-width"
                                                           onClick={() => this.viewClassPapers(selectClass)}>
                                                           {`${language[lang].QuizesAndTestPapers}`}
                                                       </Button> : null
                                               }
                                           </div> :
                                           <div className={"button-ctrl"}>

                                               {
                                                   (selectClass.teacher.privileges.split(':')[0] === '1' &&
                                                       (selectClass.firstWeekFree && firstWeek) &&
                                                       selectClass.buttonStatus === constants.BUY_TEXT) ?
                                                       <Button
                                                           className="com-btn log-btn mt-3 auto-width"
                                                           onClick={() => this.joinClass(selectClass)}>
                                                           {`${language[lang].JoinTheClass}`}
                                                       </Button> : null
                                               }
                                               {
                                                   (selectClass.teacher.privileges.split(':')[1] === '1' &&
                                                       (selectClass.firstWeekFree && firstWeek) &&
                                                       selectClass.buttonStatus === constants.BUY_TEXT) ?
                                                       <Button
                                                           className="com-btn log-btn mt-3 auto-width"
                                                           onClick={() => this.viewClassLessons(selectClass)}>
                                                           {`${language[lang].ClassResources}`}
                                                       </Button> : null
                                               }
                                               {
                                                   (selectClass.teacher.privileges.split(':')[1] === '1' &&
                                                       (selectClass.firstWeekFree && firstWeek) &&
                                                       selectClass.buttonStatus === constants.BUY_TEXT) ?
                                                       <Button
                                                           className="com-btn log-btn mt-3 auto-width"
                                                           onClick={() => this.viewClassPapers(selectClass)}>
                                                           {`${language[lang].QuizesAndTestPapers}`}
                                                       </Button> : null
                                               }
                                               {
                                                   selectClass.buttonStatus === constants.BUY_TEXT  ?
                                                       <Button
                                                           id="pay-btn"
                                                           className="com-btn log-btn mt-3 auto-width"
                                                           onClick={() => this.purchaseHandler(new Date(), selectClass.id,selectClass)}>
                                                           {`${language[lang].PurchaseTheClassPass} (${parseFloat(selectClass.fee ? selectClass.fee : 0).toFixed(2)})`}
                                                           {/*for ${moment(new Date()).format("MMM")}*/}
                                                       </Button> : null
                                               }
                                               {
                                                   selectClass.buttonStatus === constants.PENDING_TEXT ?
                                                       <Button
                                                           className="com-btn pending-btn mt-3 auto-width">
                                                           {`${language[lang].PaymentPending}`}
                                                           {/*for ${moment(new Date()).format("MMM")}*/}
                                                       </Button> : null
                                               }
                                               {
                                                   (selectClass.teacher.privileges.split(':')[0] === '1' &&
                                                       selectClass.buttonStatus === constants.BOUGHT_TEXT) ?
                                                       <Button
                                                           className="com-btn log-btn mt-3 auto-width"
                                                           onClick={() => commonFunc.joinClassHandler(this.props, selectClass)}>
                                                           {`${language[lang].JoinTheClass}`}
                                                       </Button> : null
                                               }
                                               {
                                                   (selectClass.teacher.privileges.split(':')[1] === '1' &&
                                                       selectClass.buttonStatus === constants.BOUGHT_TEXT) ?
                                                       <Button
                                                           className="com-btn log-btn mt-3 auto-width"
                                                           onClick={() => this.viewClassLessons()}>
                                                           {`${language[lang].ClassResources}`}
                                                       </Button> : null
                                               }
                                               {
                                                   (selectClass.teacher.privileges.split(':')[3] === '1' &&
                                                       selectClass.buttonStatus === constants.BOUGHT_TEXT) ?
                                                       <Button
                                                           className="com-btn log-btn mt-3 auto-width"
                                                           onClick={() => this.viewClassPapers(selectClass)}>
                                                           {`${language[lang].QuizesAndTestPapers}`}
                                                       </Button> : null
                                               }
                                           </div>
                                   }
                               </div>:null
                            }
                        </div>
                        }
                    </main>
                    <CardsFooter/>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    selectClass: state.classes.selectClass,
    listOfLectures: state.classes.listOfLectures,
    pagination: state.classes.pagination,
    userObj: state.student.userObj
});


const mapDispatchToProps = (dispatch) => ({
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
